import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CompanyLayout } from '../../components/Layout';
import { useAuth } from '../../hooks';

export const EmployeeAccessRestrictedPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/auth/login', { replace: true });
  };

  return (
    <CompanyLayout>
      <Box
        sx={{
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Card sx={{ maxWidth: 520, width: '100%', boxShadow: 3 }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
              従業員向け機能は未実装です
            </Typography>
            <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
              現在のリリースでは、従業員アカウントから利用できる専用機能（AI学習チャット等）は提供していません。
            </Typography>
            <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
              ご不明点がある場合は企業管理者にお問い合わせいただくか、管理者権限でログインしてください。
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 4 }}
              onClick={handleLogout}
            >
              ログアウトしてログイン画面へ戻る
            </Button>
          </CardContent>
        </Card>
      </Box>
    </CompanyLayout>
  );
};

export default EmployeeAccessRestrictedPage;
